export class WorkspaceNetworkingSettings {
    'vpcPeering';
    'privateLinks';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcPeering",
            "baseName": "vpcPeering",
            "type": "VpcPeering",
            "format": ""
        },
        {
            "name": "privateLinks",
            "baseName": "privateLinks",
            "type": "Array<PrivateLink>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceNetworkingSettings.attributeTypeMap;
    }
    constructor() {
    }
}
